import { useState } from "react";
import { Plus, Pencil, Trash2, Check, X, Users, Globe } from "lucide-react";

const display = "font-display";

export default function CaseBar({ cases, activeCase, onSelect, onCreate, onRename, onDelete, onManageCollabs }) {
  const [creating, setCreating] = useState(false);
  const [renaming, setRenaming] = useState(false);
  const [name, setName] = useState("");

  const submitCreate = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await onCreate(name.trim());
    setName("");
    setCreating(false);
  };

  const submitRename = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    await onRename(activeCase, name.trim());
    setName("");
    setRenaming(false);
  };

  const active = cases.find((c) => c.case_id === activeCase);

  return (
    <div className="max-w-6xl mx-auto w-full px-6 pb-2">
      <div className="flex flex-wrap items-center gap-2" data-testid="case-bar">
        <span className={`${display} text-[10px] uppercase tracking-[0.15em] text-gray-400 mr-1`}>Timelines:</span>
        {cases.map((c) => (
          <button
            key={c.case_id}
            onClick={() => onSelect(c.case_id)}
            data-testid={`case-pill-${c.case_id}`}
            className={`px-3 py-1.5 rounded-lg text-xs font-semibold border transition-colors duration-200 ${c.case_id === activeCase ? "bg-[#f59e0b] text-gray-950 border-[#f59e0b]" : "bg-gray-950 text-gray-300 border-white/10 hover:border-[#f59e0b]/40 hover:text-white"}`}
          >
            {c.name} <span className={`font-mono text-[9px] ${c.case_id === activeCase ? "text-gray-800" : "text-gray-500"}`}>({c.event_count})</span>
            {c.my_role && c.my_role !== "owner" && (
              <span className="ml-1 text-[8px] font-mono font-bold uppercase text-[#2dd4bf]" data-testid={`shared-badge-${c.case_id}`}>· shared</span>
            )}
            {c.is_public && <Globe className="inline w-2.5 h-2.5 ml-1 text-emerald-500" />}
          </button>
        ))}

        {creating ? (
          <form onSubmit={submitCreate} className="flex items-center gap-1">
            <input
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="new-case-input"
              placeholder="New timeline name..."
              className="bg-gray-950 border border-[#f59e0b]/40 rounded-lg px-3 py-1.5 text-xs text-gray-200 focus:outline-none w-44"
            />
            <button type="submit" data-testid="new-case-save-btn" className="text-emerald-400 hover:text-emerald-300 p-1"><Check className="w-4 h-4" /></button>
            <button type="button" onClick={() => { setCreating(false); setName(""); }} className="text-gray-500 hover:text-white p-1"><X className="w-4 h-4" /></button>
          </form>
        ) : renaming ? (
          <form onSubmit={submitRename} className="flex items-center gap-1">
            <input
              autoFocus
              value={name}
              onChange={(e) => setName(e.target.value)}
              data-testid="rename-case-input"
              placeholder="Rename timeline..."
              className="bg-gray-950 border border-[#2dd4bf]/40 rounded-lg px-3 py-1.5 text-xs text-gray-200 focus:outline-none w-44"
            />
            <button type="submit" data-testid="rename-case-save-btn" className="text-emerald-400 hover:text-emerald-300 p-1"><Check className="w-4 h-4" /></button>
            <button type="button" onClick={() => { setRenaming(false); setName(""); }} className="text-gray-500 hover:text-white p-1"><X className="w-4 h-4" /></button>
          </form>
        ) : (
          <>
            <button
              onClick={() => setCreating(true)}
              data-testid="new-case-btn"
              className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-semibold border border-dashed border-white/20 text-gray-400 hover:text-[#f59e0b] hover:border-[#f59e0b]/40 transition-colors duration-200"
            >
              <Plus className="w-3.5 h-3.5" /> New Timeline
            </button>
            {active && (
              <div className="flex items-center gap-1 ml-1">
                {(!active.my_role || active.my_role === "owner") && (
                  <>
                    <button onClick={() => { setRenaming(true); setName(active.name); }} data-testid="rename-case-btn" title="Rename timeline" className="text-gray-500 hover:text-[#2dd4bf] p-1 transition-colors duration-200">
                      <Pencil className="w-3.5 h-3.5" />
                    </button>
                    <button onClick={() => onManageCollabs(activeCase)} data-testid="manage-collabs-btn" title="Invite collaborators to this timeline" className="text-gray-500 hover:text-[#f59e0b] p-1 transition-colors duration-200">
                      <Users className="w-3.5 h-3.5" />
                    </button>
                    {cases.length > 1 && (
                      <button onClick={() => onDelete(activeCase)} data-testid="delete-case-btn" title="Delete this timeline and all its data" className="text-gray-500 hover:text-rose-400 p-1 transition-colors duration-200">
                        <Trash2 className="w-3.5 h-3.5" />
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
